import {
  AgentLanguage,
  AgentLanguageValue
} from '../agent-language/agent-language'

export type ExclusionType = 'CODE' | 'INPUT' | 'URL' | 'QUEUE'

export const exclusionTypeI18nConfig: Record<ExclusionType, string> = {
  INPUT: 'title_applicationExclusion_exclusionTypeInput',
  CODE: 'title_applicationExclusion_exclusionTypeCode',
  URL: 'title_applicationExclusion_exclusionTypeUrl',
  QUEUE: 'title_applicationExclusion_exclusionTypeQueue'
}

export function getExclusionTypes(
  language: AgentLanguageValue
): ExclusionType[] {
  const disabledLanguages = [
    AgentLanguage.NODE.getValue(),
    AgentLanguage.PYTHON.getValue(),
    AgentLanguage.RUBY.getValue(),
    AgentLanguage.GO.getValue()
  ]

  const queueValidLanguages = [
    AgentLanguage.JAVA.getValue(),
    AgentLanguage.DOTNET_CORE.getValue()
  ]

  const availableExclusionTypes: ExclusionType[] = disabledLanguages.includes(
    language
  )
    ? []
    : ['CODE']

  availableExclusionTypes.push('INPUT')
  availableExclusionTypes.push('URL')

  if (queueValidLanguages.includes(language)) {
    availableExclusionTypes.push('QUEUE')
  }

  return availableExclusionTypes
}
